import { getItems } from "../Api";
import { EMediaType, ESizeType, Media } from "../Media/Media";
export interface ProductSubscription {
  id: string;
  code: string;
  name: string;
  description: string;
  highLevelDescription?: string;
  highlights?: string[];
  classification: Classification;
  prices: ProductPrice[];
  quantity: number;
  maintenanceType: EMaintenanceType;
  media: Media[];
}

export interface ProductPrice {
  id: string;
  price: number;
  stripePriceId: string;
  paymentType: EFrequencyPaymentType;
  vatRate?: number;
}

export enum EMaintenanceType {
  Boiler = "Boiler",
  Solar = "Solar",
  Insulation = "Insulation",
  HeatPump = "HeatPump",
  EvCharger = "EvCharger"
}

export enum EFrequencyPaymentType {
  Once = "Once",
  Weekly = "Weekly",
  BiWeekly = "BiWeekly",
  Monthly = "Monthly",
  Yearly = "Yearly"
}

export interface Classification {
  id: string;
  code: string;
  name: string;
}

export const getFirstImage = (product: ProductSubscription) => {
  return product.media
    ?.find((m) => m.mediaType === EMediaType.Image)
    ?.mediaFiles.find((m) => m.sizeType === ESizeType.Original);
};

export async function getProductSubscriptions() {
  return getItems<ProductSubscription>("pricing/product/subscriptions");
}
